import React from 'react'
import OfferedServices from './OfferedServices'

function Services() {
  return (
    <div className='pt-14'>
      <OfferedServices />
    </div>
  )
}

export default Services
